"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usaStatesList = void 0;
exports.usaStatesList = [
    {
        value: "13",
        label: "AL",
    },
    {
        value: "14",
        label: "AK",
    },
    {
        value: "15",
        label: "AZ",
    },
    {
        value: "16",
        label: "AR",
    },
    {
        value: "17",
        label: "CA",
    },
    {
        value: "18",
        label: "CO",
    },
    {
        value: "19",
        label: "CT",
    },
    {
        value: "20",
        label: "DE",
    },
    {
        value: "21",
        label: "DC",
    },
    {
        value: "22",
        label: "FL",
    },
    {
        value: "23",
        label: "GA",
    },
    {
        value: "24",
        label: "HI",
    },
    {
        value: "25",
        label: "ID",
    },
    {
        value: "26",
        label: "IL",
    },
    {
        value: "27",
        label: "IN",
    },
    {
        value: "28",
        label: "IA",
    },
    {
        value: "29",
        label: "KS",
    },
    {
        value: "30",
        label: "KY",
    },
    {
        value: "31",
        label: "LA",
    },
    {
        value: "32",
        label: "ME",
    },
    {
        value: "33",
        label: "MD",
    },
    {
        value: "34",
        label: "MA",
    },
    {
        value: "35",
        label: "MI",
    },
    {
        value: "36",
        label: "MN",
    },
    {
        value: "37",
        label: "MS",
    },
    {
        value: "38",
        label: "MO",
    },
    {
        value: "39",
        label: "MT",
    },
    {
        value: "40",
        label: "NE",
    },
    {
        value: "41",
        label: "NV",
    },
    {
        value: "42",
        label: "NH",
    },
    {
        value: "43",
        label: "NJ",
    },
    {
        value: "44",
        label: "NM",
    },
    {
        value: "45",
        label: "NY",
    },
    {
        value: "46",
        label: "NC",
    },
    {
        value: "47",
        label: "ND",
    },
    {
        value: "48",
        label: "OH",
    },
    {
        value: "49",
        label: "OK",
    },
    {
        value: "50",
        label: "OR",
    },
    {
        value: "51",
        label: "PA",
    },
    {
        value: "52",
        label: "RI",
    },
    {
        value: "53",
        label: "SC",
    },
    {
        value: "54",
        label: "SD",
    },
    {
        value: "55",
        label: "TN",
    },
    {
        value: "56",
        label: "TX",
    },
    {
        value: "57",
        label: "UT",
    },
    {
        value: "58",
        label: "VT",
    },
    {
        value: "59",
        label: "VA",
    },
    {
        value: "60",
        label: "WA",
    },
    {
        value: "61",
        label: "WV",
    },
    {
        value: "62",
        label: "WI",
    },
    {
        value: "63",
        label: "WY",
    },
    {
        value: "66",
        label: "AS",
    },
    {
        value: "67",
        label: "FM",
    },
    {
        value: "68",
        label: "GU",
    },
    {
        value: "69",
        label: "MH",
    },
    {
        value: "70",
        label: "MP",
    },
    {
        value: "71",
        label: "PW",
    },
    {
        value: "72",
        label: "VI",
    },
    {
        value: "PR",
        label: "PR",
    },
];
